/* global $:false */

export default class ShoppingCartDropdown {
  static init () {
    new ShoppingCartDropdown().init()
  }

  constructor () {
    this.dropdownContainer = $('[data-shopping-cart-dropdown]')
    this.dropdownToggler = $('[data-shopping-cart-dropdown-toggler]')
  }

  init () {
    this.setupBindings()
  }

  setupBindings () {
    this._closeShoppingCartOnOutsideClick()
    this._toggleShoppingCartOnTogglerClick()
  }

  showShoppingCart () {
    this.dropdownContainer.removeClass('c-shopping-cart-dropdown--hidden')
  }

  _toggleShoppingCartOnTogglerClick () {
    this.dropdownToggler.click(e => {
      e.preventDefault()
      this._toggleShoppingCart()
    })
  }

  _closeShoppingCartOnOutsideClick () {
    if (!(this.dropdownContainer.length > 0) && !(this.dropdownToggler.length > 0)) { return }
    // https://stackoverflow.com/questions/11545518/hide-a-div-when-clicked-outside-of-it
    return $(document).click(e => {
      const clickedOutsideShoppingCart = !this.dropdownContainer.find(e.target).length
      const clickedOutsideShoppingCartToggler = !this.dropdownToggler.find(e.target).length
      if (clickedOutsideShoppingCart && clickedOutsideShoppingCartToggler) {
        this._hideShoppingCart()
      }
    })
  }

  _toggleShoppingCart () {
    this.dropdownContainer.toggleClass('c-shopping-cart-dropdown--hidden')
  }

  _hideShoppingCart () {
    this.dropdownContainer.addClass('c-shopping-cart-dropdown--hidden')
  }
}
